import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box, Button, Paper, TextField, Typography, Stack, Alert, Avatar, InputAdornment,
} from "@mui/material";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { login } from "../../services/authService";
import { APP_NOME } from "../../config/appConfig";

export default function Login() {
  const navigate = useNavigate();
  const [loginStr, setLoginStr] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");
  const [carregando, setCarregando] = useState(false);

  const entrar = async () => {
    setErro("");
    setCarregando(true);
    try {
      await login(loginStr, senha);
      navigate("/fichas");
    } catch (e) {
      const msg = e?.response?.data?.mensagem || e?.response?.data || "Falha na autenticação.";
      setErro(typeof msg === "string" ? msg : "Falha na autenticação.");
    } finally {
      setCarregando(false);
    }
  };

  return (
    <Box sx={{
      minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 2,
      background: "linear-gradient(135deg, #0f1b3d 0%, #3b5bdb 100%)",
    }}>
      <Paper elevation={8} sx={{ p: 4, width: 400, borderRadius: 3 }}>
        <Stack alignItems="center" spacing={1} mb={3}>
          <Avatar sx={{ bgcolor: "primary.main", width: 56, height: 56 }}>
            <VolunteerActivismIcon />
          </Avatar>
          <Typography variant="h5" align="center">{APP_NOME}</Typography>
          <Typography variant="body2" align="center" color="text.secondary">
            Acesse o painel administrativo
          </Typography>
        </Stack>

        {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}

        <Stack spacing={2}>
          <TextField label="Usuário ou e-mail" value={loginStr} fullWidth size="medium"
            onChange={(e) => setLoginStr(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && entrar()}
            InputProps={{ startAdornment: <InputAdornment position="start"><PersonOutlineIcon fontSize="small" /></InputAdornment> }} />
          <TextField label="Senha" type="password" value={senha} fullWidth size="medium"
            onChange={(e) => setSenha(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && entrar()}
            InputProps={{ startAdornment: <InputAdornment position="start"><LockOutlinedIcon fontSize="small" /></InputAdornment> }} />
          <Button variant="contained" size="large" onClick={entrar} disabled={carregando} sx={{ py: 1.2 }}>
            {carregando ? "Aguarde…" : "Entrar"}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
}
